export const positions = {
  TOP: 'top',
  // Deprecated
  RIGHT: 'right',
  // Deprecated
  BOTTOM: 'bottom',
  // Deprecated
  LEFT: 'left',
  // Deprecated
  top: 'top',
  right: 'right',
  bottom: 'bottom',
  left: 'left'
};
export const styles = {
  top: {
    transform: 'translate(-50%, -100%)',
    textAlign: 'center',
    borderWidth: '6px 5px 0 5px',
    borderColor: 'var(--neutral-surface-inverse) transparent transparent transparent'
  },
  bottom: {
    transform: 'translate(-50%, 100%)',
    textAlign: 'center',
    borderWidth: '0px 5px 6px 5px',
    borderColor: 'transparent transparent var(--neutral-surface-inverse) transparent'
  },
  left: {
    transform: 'translate(-100%, -50%)',
    textAlign: 'left',
    borderWidth: '5px 0px 5px 6px',
    borderColor: 'transparent transparent transparent var(--neutral-surface-inverse)'
  },
  right: {
    transform: 'translate(100%, -50%)',
    textAlign: 'left',
    borderWidth: '5px 6px 5px 0',
    borderColor: 'transparent var(--neutral-surface-inverse) transparent transparent'
  }
};